import React, { useRef, useState } from "react";
import "./trending-now.css";
import Common_title from "../../common-components/common-title/Common_title";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import Trending_product_card from "../../common-components/common-card/trending-product/Trending_product_card";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

const Trending_now = ({ products }) => {
  const menproduct = [
    {
      image: "/assets/images/home/trending-now/trend1.png",
      name: "Antanio donati",
      model_no: "MODEL NO-AD1127",
    },
    {
      image: "/assets/images/home/trending-now/trend2.png",
      name: "Puma",
      model_no: "MODEL NO-AD1127",
    },
    {
      image: "/assets/images/home/trending-now/trend3.png",
      name: "Raybon",
      model_no: "MODEL NO-AD1127",
    },
    {
      image: "/assets/images/home/trending-now/trend1.png",
      name: "Antanio donati",
      model_no: "MODEL NO-AD1127",
    },
    {
      image: "/assets/images/home/trending-now/trend2.png",
      name: "Puma",
      model_no: "MODEL NO-AD1127",
    },
    {
      image: "/assets/images/home/trending-now/trend3.png",
      name: "Raybon",
      model_no: "MODEL NO-AD1127",
    },
  ];

  const mensgoggle = [
    {
      image: "/assets/images/home/trending-now/goggle.png",
    },
    {
      image: "/assets/images/home/trending-now/goggle1.png",
    },
    {
      image: "/assets/images/home/trending-now/goggle2.png",
    },
    {
      image: "/assets/images/home/trending-now/goggle1.png",
    },
    {
      image: "/assets/images/home/trending-now/goggle.png",
    },
    {
      image: "/assets/images/home/trending-now/goggle1.png",
    },
  ];

  return (
    <>
      <section className="Trending_now_sec">
        <div className="bgbottomdiv">
          <img
            className="layerimg"
            src={
              process.env.PUBLIC_URL +
              "/assets/images/home/trending-now/bg-layer.png"
            }
          />
        </div>
        <div className="container">
          <Common_title title={"Trending"} titleblack={"Now"} />

          <div className="tabsec">
            <Tab.Container id="left-tabs-example" defaultActiveKey="Men">
              <Nav variant="pills" className="flex-row">
                <Nav.Item>
                  <Nav.Link eventKey="Men">
                    <span>Men</span>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="Women">
                    <span>Women</span>
                  </Nav.Link>
                </Nav.Item>
              </Nav>

              <Tab.Content>
                <Tab.Pane eventKey="Men">
                  <div className="flexsec">
                    <div className="leftflex">
                      <div className="leftsec">
                        <div className="personimgdiv">
                          <img
                            className="personimg"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/home/trending-now/boy.png"
                            }
                            alt="personimg"
                          />
                        </div>
                        <div className="goggleswiper">
                          <Swiper
                            slidesPerView={1}
                            centeredSlides={true}
                            autoplay={{
                              delay: 1000,
                              disableOnInteraction: false,
                            }}
                            breakpoints={{
                              0: {
                                slidesPerView: 2,
                                spaceBetween: 5,
                              },
                              400: {
                                slidesPerView: 3,
                                spaceBetween: 5,
                              },
                              991: {
                                slidesPerView: 5,
                                spaceBetween: 5,
                              },
                              1200: {
                                slidesPerView: 5,
                                spaceBetween: 5,
                              },
                            }}
                            className="mySwiper"
                            modules={[Autoplay]}
                          >
                            {products?.map(
                              (data, index) =>
                                data?.Gender?.id === 1 && (
                                  <SwiperSlide>
                                    <div className="slidediv">
                                      <img
                                        className="goggle_img"
                                        src={
                                          process.env.REACT_APP_IMAGE_URL +
                                          data.image
                                        }
                                      />
                                    </div>
                                  </SwiperSlide>
                                )
                            )}
                          </Swiper>
                        </div>
                      </div>
                    </div>
                    <div className="rightflex">
                      <div className="rightsec">
                        <div className="tending_product_slider">
                          <Swiper
                            slidesPerView={1}
                            breakpoints={{
                              0: {
                                slidesPerView: 2,
                                spaceBetween: 10,
                              },
                              575: {
                                slidesPerView: 3,
                                spaceBetween: 10,
                              },
                              1024: {
                                slidesPerView: 3,
                                spaceBetween: 10,
                              },
                            }}
                            className="mySwiper"
                          >
                            {products?.map(
                              (data, index) =>
                                data?.Gender?.id === 1 && (
                                  <SwiperSlide>
                                    <Trending_product_card
                                      id={data?.Product?.id}
                                      image={data?.Product?.image}
                                      name={data?.Product?.name}
                                      // prono={data.Product_Variants[0]?.model_no}
                                    />
                                  </SwiperSlide>
                                )
                            )}
                          </Swiper>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab.Pane>

                <Tab.Pane eventKey="Women">
                  <div className="flexsec">
                    <div className="leftflex">
                      <div className="leftsec">
                        <div className="personimgdiv">
                          <img
                            className="personimg"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/home/trending-now/girl2.png"
                            }
                            alt="personimg"
                          />
                        </div>
                        <div className="goggleswiper">
                          <Swiper
                            slidesPerView={1}
                            centeredSlides={true}
                            autoplay={{
                              delay: 1000,
                              disableOnInteraction: false,
                            }}
                            breakpoints={{
                              0: {
                                slidesPerView: 2,
                                spaceBetween: 5,
                              },
                              400: {
                                slidesPerView: 3,
                                spaceBetween: 5,
                              },
                              991: {
                                slidesPerView: 5,
                                spaceBetween: 5,
                              },
                              1200: {
                                slidesPerView: 5,
                                spaceBetween: 5,
                              },
                            }}
                            className="mySwiper"
                            modules={[Autoplay]}
                          >
                            {products?.map(
                              (data, index) =>
                                data?.Gender?.id === 2 && (
                                  <SwiperSlide>
                                    <div className="slidediv">
                                      <img
                                        className="goggle_img"
                                        src={
                                          process.env.REACT_APP_IMAGE_URL +
                                          data.image
                                        }
                                      />
                                    </div>
                                  </SwiperSlide>
                                )
                            )}
                          </Swiper>
                        </div>
                      </div>
                    </div>
                    <div className="rightflex">
                      <div className="rightsec">
                        <div className="tending_product_slider">
                          <Swiper
                            slidesPerView={1}
                            breakpoints={{
                              0: {
                                slidesPerView: 2,
                                spaceBetween: 10,
                              },
                              575: {
                                slidesPerView: 3,
                                spaceBetween: 10,
                              },
                              1024: {
                                slidesPerView: 3,
                                spaceBetween: 10,
                              },
                            }}
                            className="mySwiper"
                          >
                            {products?.map(
                              (data, index) =>
                                data?.Gender?.id === 2 && (
                                  <SwiperSlide>
                                    <Trending_product_card
                                      id={data?.Product?.id}
                                      image={data?.Product?.image}
                                      name={data?.Product?.name}
                                      // prono={data.Product_Variants[0]?.model_no}
                                    />
                                  </SwiperSlide>
                                )
                            )}
                          </Swiper>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </section>
    </>
  );
};

export default Trending_now;
